import styles from "../../styles/setting.module.scss";
import {
  useEffect,
  useState,
  useRef,
  use,
  cloneElement,
  useCallback,
  SetStateAction,
} from "react";
import http from "../../http";
import Image from "next/image";
import { useTheme, useUserInfo } from "../../context/ThemeContext";
import {
  Button,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popover,
  QRCode,
  Radio,
  RadioChangeEvent,
  Segmented,
  Space,
  Spin,
  Table,
  Tabs,
  Tooltip,
} from "antd";
import {
  CreditCardOutlined,
  ExclamationCircleOutlined,
  HistoryOutlined,
  InfoCircleOutlined,
  SkinOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useRouter } from "next/router";
import classNames from "classnames";
import PointsLog from "./PointsLog";
import Points from "./Points";
import { getFreeTimes } from "../api/wiki";
import { useCommonData } from "../../layout/ELayout";

interface productType {
  alias: string;
  description: string;
  discount_price: number;
  name: string;
  price: number;
  status: number;
  timestamp: string;
  update_timestamp: string;
  uuid: string;
}
export default function SettingModal(props: {
  tabKey?: string;
  children: JSX.Element;
}) {
  const { userInfo, getUserInfo, toggleUserInfo } = useUserInfo();
  const { theme, toggleTheme } = useTheme();
  const [form] = Form.useForm();
  const router = useRouter();
  const [showEdit, setShowEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [key, setKey] = useState(props.tabKey || "user");
  const phone_number = Form.useWatch("phone_number", form);
  const [recall, setRecall] = useState(false);
  const [recallCount, setRecallCount] = useState(60);
  const [payType, setPayType] = useState<"ali" | "wx">("ali");
  const [orderType, setOrderType] = useState("weekly");
  const { commonData, changeCommonData } = useCommonData();
  const [productList, setProductList] = useState<
    Array<{
      alias: string;
      description: string;
      discount_price: number;
      name: string;
      price: number;
      status: number;
      timestamp: string;
      update_timestamp: string;
      uuid: string;
      type: 0 | 1;
      is_buy: boolean;
    }>
  >([]);
  const [orderItem, setOrderItem] = useState<productType>();
  const [QRStatus, setQRStatus] = useState<any>("loading");
  const [QRUrl, setQRUrl] = useState("loading");
  const [wxPayOpen, setWxPayOpen] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [logList, setLogList] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [pageData, setPageData] = useState({
    page: 1,
    page_size: 10,
    total: 0,
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [modalUserInfo, setModalUserInfo] = useState<any>();
  const columns = [
    {
      title: "支付时间",
      dataIndex: "timestamp",
      key: "timestamp",
      with: 150,
    },
    {
      title: "支付方式",
      dataIndex: "payment_type",
      key: "payment_type",
      with: 150,
    },
    {
      title: "支付金额",
      dataIndex: "amount",
      key: "amount",
      with: 150,
    },
    {
      title: "支付渠道",
      dataIndex: "payment_method",
      key: "payment_method",
      with: 150,
    },
    {
      title: "支付状态",
      dataIndex: "status",
      key: "status",
      with: 150,
    },
  ];
  const content = (
    <div
      style={{
        width: "70%",
        border: "1px dashed var(--border-color)",
        marginTop: 16,
        padding: 8,
        borderRadius: 16,
      }}
    >
      <div style={{ fontSize: 16, fontWeight: "bold", marginBottom: 8 }}>
        会员新增权益
      </div>
      <p>新用户专享卡：额外赠送5积分。</p>
      <p>周卡：额外赠送10积分。</p>
      <p>季卡：额外赠送100积分。</p>
      <p>年卡：额外赠送500积分。</p>
    </div>
  );
  const btn = cloneElement(props.children, {
    onClick: () => {
      setIsModalOpen(true);
      setKey(props.tabKey || "user");
      getPayProducts();
      // getFreeTimes().then((res) => {
      //   changeCommonData({ freeTimes: res.data.count });
      // });
    },
  });
  useEffect(() => {
    if (isModalOpen) {
      http.post(`/api/v1/account/info`).then((data: any) => {
        if (data.status) {
          if (data.data.subscription_expired) {
            const [datePart] = data.data.subscription_expired.split(" ");
            data.data.subscription_expired = datePart;
          }
          setModalUserInfo({ ...data.data, login: true });
        } else {
          message.error(data.message);
        }
      });
    }
  }, [isModalOpen]);

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (userInfo.login) {
      if (form && isModalOpen && key === "user") {
        // 如果用户信息已存在且表单已加载，设置表单值
        setTimeout(() => {
          form.setFieldsValue(userInfo);
        });
      }
      if (isModalOpen && key === "log") {
        getLog(pageData);
      }
    }
  }, [userInfo, form, isModalOpen, key]);
  useEffect(() => {
    setModalUserInfo(userInfo);
  }, [userInfo]);
  const getInfo = async () => {
    await getUserInfo();
  };

  const saveInfo = () => {
    form.validateFields().then((values) => {
      const params = values;
      delete params.password2;
      http.put("/api/v1/account/edit", params).then((res: any) => {
        if (res.status) {
          setShowEdit(false);
          form.setFieldValue("password", "");
          form.setFieldValue("password2", "");
          getInfo();
        } else {
          message.error(res.message);
        }
      });
    });
  };
  const changeTheme = (newTheme: string) => {
    setBtnLoading(true);
    toggleTheme(newTheme);
    setBtnLoading(false);
  };
  const getCode = () => {
    setRecall(true);
    //  倒计时60秒
    const timer = setInterval(() => {
      setRecallCount((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setRecall(false);
          return 60;
        }
        return prev - 1;
      });
    }, 1000);
    if (!phone_number) {
      message.error("请输入手机号");
      return;
    } else if (!/^1[3456789]\d{9}$/.test(phone_number)) {
      message.error("请输入正确的手机号");
      return;
    }
    http
      .post("/api/v1/account/code", { phone_number: phone_number })
      .then((res: any) => {
        if (res.status) {
        } else {
          message.error(res.message);
        }
      });
  };
  const goGithub = () => {
    http.get("/api/v1/thirdparty/github/login").then((res: any) => {
      if (res.status) {
        window.open(res.data.authorization_url);
      }
    });
  };
  const goGitee = () => {
    if (userInfo.is_bind_gitee) return;
    http.get("/api/v1/thirdparty/gitee/login").then((res: any) => {
      if (res.status) {
        window.open(res.data.authorization_url);
      }
    });
  };
  const onPayTypeChange = (value: "ali" | "wx") => {
    setPayType(value);
  };
  const onChange = (e: RadioChangeEvent) => {
    setOrderType(e.target.value);
  };
  const getPayProducts = () => {
    http.get("/api/v1/payment/products").then((res: any) => {
      if (res.status) {
        setProductList(res.data);
        setOrderItem(res.data[1]);
        setOrderType(res.data[1].alias);
      }
    });
  };
  const bindCard = (payType: string, payNum: number = 1) => {
    if (payType === "wx") {
      setWxPayOpen(true);
      setQRStatus("loading");
      let data: any = {
        product_id: orderItem?.uuid,
        pay_type: "weixin_native",
      };
      if (key === "points") {
        data = {
          product_id: productList.find(
            (item: any) => item.alias === "points_custom"
          )?.uuid,
          pay_type: "weixin_native",
          num: payNum,
        };
      }
      http.post("/api/v1/payment/pay", data).then((res: any) => {
        if (res.status) {
          setQRUrl(res.data);
          setQRStatus("active");
        }
      });
    } else {
      let data: any = {
        product_id: orderItem?.uuid,
        pay_type: "ali",
      };
      if (key === "points") {
        data = {
          product_id: productList.find(
            (item: any) => item.alias === "points_custom"
          )?.uuid,
          pay_type: "ali",
          num: payNum,
        };
      }
      http
        .post("/api/v1/payment/pay", data)
        .then((res: any) => {
          if (res.status) {
            // let divForm = document.getElementsByTagName("divform");
            // if (divForm.length) {
            //   document.body.removeChild(divForm[0]);
            // }
            // const div = document.createElement("divform");
            // div.innerHTML = res.data;
            // document.body.appendChild(div);
            // document.forms[0].acceptCharset = "UTF-8";
            // document.forms[0].setAttribute("target", "_blank");

            // //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
            // document.forms[0].submit();

            window.open(res.data);
          } else {
            message.error(res.message);
          }
        })
        .catch((err: any) => {
          message.error(err.message);
        });
    }
  };
  const getLog = (pageData: {
    page: number;
    page_size: number;
    total: number;
  }) => {
    setTableLoading(true);
    http
      .get(
        `/api/v1/payment/order_history?page=${pageData.page}&page_size=${pageData.page_size}`
      )
      .then((res: any) => {
        if (res.status) {
          setLogList(res.data.orders);
          setPageData({ ...pageData, total: res.data.total_orders });
          setTableLoading(false);
        } else {
          message.error(res.message);
          setTableLoading(false);
        }
      });
  };

  // const getWikiDiscount = (account_type?: string) => {
  //   if (!account_type) return "无折扣";
  //   const n = String(account_type).toLowerCase();
  //   if (n.includes("yearly")) return "4折";
  //   if (n.includes("seasonal")) return "5折";
  //   if (n.includes("weekly")) return "7折";
  //   if (n.includes("daily")) return "8折";
  //   return "无折扣";
  // };
  const accountTypeMap: any = {
    seasonal: "季卡会员",
    yearly: "年卡会员",
    weekly: "周卡会员",
    daily: "日卡会员",
  };
  const tabList = [
    {
      key: "user",
      label: `个人信息`,
      icon: <UserOutlined />,
      children: (
        <div className={styles.wraper}>
          <div className={styles.settingBody}>
            <div className={styles.left}>
              <Form
                name="basic"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                autoComplete="off"
                form={form}
                disabled={!showEdit}
              >
                <Form.Item
                  label="用户名"
                  name="username"
                  rules={[{ required: showEdit, message: "请输入您的用户名" }]}
                >
                  <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                  label="用户邮箱"
                  name="email"
                  rules={[{ required: false, message: "请输入您的邮箱" }]}
                >
                  <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                  label="手机号"
                  name="phone_number"
                  rules={[{ required: showEdit, message: "请输入您的手机号" }]}
                >
                  <Input autoComplete="off" />
                </Form.Item>
                {phone_number !== userInfo.phone_number && (
                  <Form.Item
                    label="验证码"
                    name="sms_code"
                    rules={[{ required: showEdit, message: "请输入验证码" }]}
                  >
                    <Input
                      autoComplete="off"
                      suffix={
                        <Button
                          type="link"
                          onClick={getCode}
                          size="small"
                          disabled={recall}
                        >
                          {`发送验证码${recall ? `(${recallCount})` : ""}`}
                        </Button>
                      }
                    />
                  </Form.Item>
                )}
                {showEdit && (
                  <Form.Item
                    label="密码"
                    name="password"
                    rules={[{ required: showEdit, message: "请输入您的密码" }]}
                  >
                    <Input.Password autoComplete="new-password" />
                  </Form.Item>
                )}
                {showEdit && (
                  <Form.Item
                    label="密码确认"
                    name="password2"
                    rules={[
                      {
                        required: showEdit,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("两次密码输入不一致")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password autoComplete="new-password" />
                  </Form.Item>
                )}
              </Form>
              <div className={styles.editBtns}>
                {showEdit ? (
                  <>
                    <Button
                      type="default"
                      onClick={() => {
                        setShowEdit(false);
                      }}
                      block
                      size="large"
                      className={styles.btn}
                    >
                      取消
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      block
                      onClick={saveInfo}
                      className={styles.btn}
                    >
                      保存
                    </Button>
                  </>
                ) : (
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => {
                      setShowEdit(true);
                    }}
                    className={styles.saveBtn}
                  >
                    修改
                  </Button>
                )}
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.quotaHeader}>我的权益</div>
              <div className={styles.quotaGrid}>
                <div className={styles.quotaItem}>
                  <div className={styles.quotaItemLabel}>会员类型</div>
                  <div className={styles.quotaItemValue}>
                    {accountTypeMap[userInfo?.account_type] ||
                      "普通用户"}
                  </div>
                </div>
                <div className={styles.quotaItem}>
                  <div className={styles.quotaItemLabel}>会员到期日期</div>
                  <div className={styles.quotaItemValue}>
                    {modalUserInfo?.subscription_expired ?? "—"}
                  </div>
                </div>
                {/* <div className={styles.quotaItem}>
                  <div className={styles.quotaItemLabel}>项目文档生成折扣</div>
                  <div className={styles.quotaItemValue}>
                    {getWikiDiscount(userInfo?.account_type)}
                  </div>
                </div> */}
                {/* <div className={styles.quotaItem}>
                  <div className={styles.quotaItemLabel}>免费生成次数</div>
                  <div className={styles.quotaItemValue}>
                    {commonData?.freeTimes ?? 0}
                  </div>
                </div> */}
                <div className={styles.quotaItem}>
                  <div className={styles.quotaItemLabel}>账户积分余额</div>
                  <div className={styles.quotaItemValue}>
                    {modalUserInfo?.points ?? 0}
                  </div>
                </div>
                <div className={styles.quotaItem}>
                  <div className={styles.quotaItemLabel}>冻结积分</div>
                  <div className={styles.quotaItemValue}>
                    {modalUserInfo?.frozen_points ?? 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Divider>第三方应用</Divider>
          <div className={styles.third_part}>
            <Space size="large">
              <Tooltip placement="top" title={"微信"}>
                <Image
                  src={
                    userInfo.is_bind_wechat
                      ? "/setting/wechat.png"
                      : "/setting/wechat_hui.png"
                  }
                  alt=""
                  width={32}
                  height={32}
                />
              </Tooltip>
              <Tooltip placement="top" title={"Github"}>
                <Image
                  onClick={goGithub}
                  src={
                    userInfo.is_bind_github
                      ? "/setting/github.png"
                      : "/setting/github_hui.png"
                  }
                  alt=""
                  width={32}
                  height={32}
                  style={{
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
              {/* <Tooltip placement="top" title={"Gitee"}>
                <Image
                  onClick={goGitee}
                  src={
                    userInfo.is_bind_gitee
                      ? "/setting/gitee.png"
                      : "/setting/gitee-hui.png"
                  }
                  alt=""
                  width={32}
                  height={32}
                  style={{
                    cursor: userInfo.is_bind_gitee ? "default" : "pointer",
                  }}
                />
              </Tooltip> */}
            </Space>
          </div>
        </div>
      ),
    },
    {
      key: "pay",
      label: `购买会员`,
      icon: <CreditCardOutlined />,
      children: (
        <div className={styles.wraper}>
          <div className={styles.formbox}>
            <div className={styles.title}>支付方式：</div>

            <div
              className={classNames(
                styles.payType,
                payType === "ali" ? styles.payActive : ""
              )}
              style={{ marginRight: "24px" }}
              onClick={() => onPayTypeChange("ali")}
            >
              <div className={styles.ali} />
              <span>支付宝</span>
            </div>
            <div
              className={classNames(
                styles.payType,
                payType === "wx" ? styles.payActive : ""
              )}
              onClick={() => onPayTypeChange("wx")}
            >
              <div className={styles.wx} />
              <span>微信</span>
            </div>
          </div>
          <div className={styles.formbox}>
            <div className={styles.title}>会员类型：</div>
            <div>
              <Radio.Group
                onChange={onChange}
                className={styles.orderTypes}
                value={orderType}
              >
                {productList
                  .filter((item) => item.type === 0)
                  .map((item) => {
                    return (
                      <Radio
                        key={item.uuid}
                        onClick={() => setOrderItem(item)}
                        value={item.alias}
                        style={{ fontSize: 16 }}
                        disabled={!item?.is_buy}
                      >
                        {item.description}
                      </Radio>
                    );
                  })}
              </Radio.Group>
            </div>
          </div>
          <div className={styles.formbox}>
            <div className={styles.title}>支付金额：</div>
            {orderType && (
              <div style={{ display: "flex", alignItems: "center" }}>
                {orderItem?.price && (
                  <span
                    className={
                      orderItem?.discount_price ? styles.originalPrice : ""
                    }
                  >
                    {orderItem?.price}元
                  </span>
                )}
                {!!orderItem?.discount_price && (
                  <div>
                    <span>限时特价</span>
                    {orderItem?.discount_price}元
                  </div>
                )}
              </div>
            )}
          </div>
          {/* <p className={styles.tips}>*请点击绑定跳转支付宝授权页面进行绑定</p> */}
          {
            <div>
              <Button
                onClick={() => bindCard(payType)}
                type="primary"
                size="large"
              >
                支付
              </Button>
            </div>
          }
          {content}
        </div>
      ),
    },
    {
      key: "points",
      label: `充值积分`,
      disabled: !productList.some((item) => item.alias == "points_custom"),
      icon: <CreditCardOutlined />,
      children: <Points userInfo={modalUserInfo} bindCard={bindCard}></Points>,
    },
    {
      key: "log",
      label: `支付历史`,
      icon: <HistoryOutlined />,
      children: (
        <div className={styles.wraper}>
          <Table
            dataSource={logList}
            style={{ width: "100%" }}
            scroll={{ y: 450 }}
            size="small"
            rowKey={"uuid"}
            columns={columns}
            loading={tableLoading}
            pagination={{
              position: ["bottomRight"],
              total: pageData.total,
              current: pageData.page,
              pageSize: pageData.page_size,
              onChange(page, pageSize) {
                const newpage = {
                  ...pageData,
                  page,
                  page_seze: pageSize,
                };
                setPageData(newpage);
                getLog(newpage);
              },
            }}
          />
        </div>
      ),
    },
    {
      key: "pointsLog",
      label: `积分明细`,
      icon: <HistoryOutlined />,
      children: <PointsLog></PointsLog>,
    },
    {
      key: "theme",
      label: `主题设置`,
      icon: <SkinOutlined />,
      children: (
        <Spin spinning={btnLoading} delay={200}>
          <div className={styles.wraper}>
            <div className={styles.settingBody}>
              <div className={styles.info_part}>
                <Radio.Group
                  defaultValue={theme}
                  block
                  buttonStyle="solid"
                  onChange={(e) => {
                    changeTheme(e.target.value);
                  }}
                >
                  <Radio.Button value="light">浅色</Radio.Button>
                  <Radio.Button value="dark">深色</Radio.Button>
                </Radio.Group>
              </div>
            </div>
          </div>
        </Spin>
      ),
    },
  ];
  const handleTabChange = useCallback((key: string) => {
    setKey(key);
  }, []);
  return (
    <>
      {btn}
      <Modal
        title={"设置"}
        open={isModalOpen}
        width={1000}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
        loading={loading}
        maskClosable={false}
        styles={{
          body: {
            minHeight: "662px",
          },
        }}
      >
        <Tabs
          activeKey={key}
          centered
          items={tabList}
          onChange={handleTabChange}
        />
        <Modal
          title="微信支付"
          open={wxPayOpen}
          okText={"支付完成"}
          width={400}
          centered
          onCancel={() => {
            setWxPayOpen(false);
          }}
          onOk={() => {
            setWxPayOpen(false);
            router.reload();
          }}
        >
          <div className={styles.QRCodeBox}>
            <QRCode status={QRStatus} value={QRUrl} size={200} errorLevel="H" />
          </div>
        </Modal>
      </Modal>
    </>
  );
}
